export interface HoleToleranceThreshold {
  metric: string;
  unit: string;
  asDesignedMax: number;
  inToleranceMax: number;
  /** Signed lower-bound threshold (typically <= 0) for the negative side. Omit/undefined for distance-only metrics with no negative side. */
  asDesignedMin?: number;
  inToleranceMin?: number;
}

export interface SiteHoleTolerance {
  siteId: number;
  thresholds: HoleToleranceThreshold[];
}

export function getThreshold(tolerance: SiteHoleTolerance | null | undefined, metric: string): HoleToleranceThreshold | undefined {
  return tolerance?.thresholds.find(t => t.metric === metric);
}
